import React, { ReactElement, useState } from "react";
import DropdownOption from "./dropdownOption";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import cx from "classnames";
type State = string[] | number[];
type OnButtonValueChange = (name: string, value: State) => void;

const DropdownMultiButton = ({
	children,
	name,
	placeholder,
	title,
	emptyValue = [],
	onChange,
	isOpen = false,
	onClick,
	value,
}: {
	children: ReactElement[];
	name: string;
	title: string;
	placeholder: string;
	emptyValue: State;
	onChange: OnButtonValueChange;
	isOpen?: boolean;
	onClick?;
	value?;
}) => {
	const onChange$ = new Subject();

	onChange$
		.pipe(
			debounceTime(1000),
			distinctUntilChanged()
		)
		.subscribe((newState: State) => {
			fireOnNewState(newState);
		});

	const [state, setState] = useState(value || (emptyValue as any));

	const fireOnNewState = (newState: State) => {
		if (newState.length === 0) {
			onChange(name, emptyValue);
		} else {
			onChange(name, newState);
		}
	};

	const updateState = (active: boolean, value) => {
		let newState = state;

		if (active && !state.includes(value)) {
			newState = [...state, value];
		}

		if (!active && state.includes(value)) {
			newState = state.filter(existingValue => existingValue !== value);
		}

		setState(newState);
		onChange$.next(newState);
	};

	const getSelectedValuesLabels = () => {
		if (isDefaultState()) {
			return placeholder;
		}

		let titles = [];
		for (let child of children) {
			const { value, title } = child.props;

			if (state.indexOf(value) > -1) {
				titles.push(title);
			}
		}

		return titles.join(", ");
	};

	const isDefaultState = (): boolean => {
		return state.length === children.length || state.length === 0;
	};

	const className = cx("filterAttribute", {
		open: isOpen,
		closed: !isOpen,
		active: !isDefaultState(),
	});
	return (
		<div className={className}>
			<div className="filterValue" onClick={onClick}>
				{getSelectedValuesLabels()}
			</div>
			<div className="filterOptions">
				<h6>{title}</h6>
				{React.Children.map(children, (child: ReactElement, key) => {
					return (
						<DropdownOption
							{...child.props}
							active={state.indexOf(child.props.value) > -1}
							key={key}
							onStateChange={updateState}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default DropdownMultiButton;
